<template>
  <of-dialog
    :title="formTitle"
    @onCancel="cancel"
    :width="width"
    :class="{ hideButton: hideConfig }"
  >
    <div slot="content">
      <el-form label-width="150px" :model="dataForm">
        <el-form-item label="名称：">
          {{ dataForm.Nickname }}
        </el-form-item>
        <el-form-item label="手机号码：">
          {{ dataForm.MobileNo?dataForm.MobileNo:"--" }}
        </el-form-item>
        <el-form-item label="邮箱：">
          {{ dataForm.Email?dataForm.Email:"--" }}
        </el-form-item>
        <el-form-item label="注册方式：">
          {{ AccountType(dataForm.AccountType) }}
        </el-form-item>
        <el-form-item label="微信名称：" v-if="dataForm.AccountType == 2">
          {{ dataForm.WeChatname }}
        </el-form-item>
        <el-form-item label="账号类型：">
          {{ dataForm.MemberType == 1 ? "个人" : "团体" }}
        </el-form-item>
        <el-form-item label="账户角色：">
          {{ showRoleType(dataForm.RoleType) }}
        </el-form-item>
        <el-form-item label="注册时间:">
          {{ (dataForm.CreateTime * 1000) | formatDate }}
        </el-form-item>
      </el-form>
    </div>
  </of-dialog>
</template>
<script>
import OfDialog from "@/components/controls/of_dialog/of_dialog";

export default {
  name: "edit",
  props: {
    dataForm: {
      type: Object,
      default: null,
    },
    formTitle: {
      type: String,
      default: "",
    },
    isEdit: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      isConfirm: false,
      hideConfig: true,
      width: "40%",
      accountType: [
        { value: 1, label: "手机" },
        { value: 2, label: "微信" },
      ],
    };
  },
  components: {
    OfDialog,
  },
  computed: {
    AccountType() {
      return (data) => {
        return data == 1 ? "PC" : "微信";
      };
    },
  },
  methods: {
    cancel() {
      this.$emit("formCallBack", null);
    },
    showRoleType(rowData) {
      let roleName = "";
      if (rowData) {
        let role = rowData.split(",");
        role.forEach((item) => {
          switch (item) {
            case "1":
              if (roleName == "") {
                roleName = "受赠者";
              } else {
                roleName = roleName + "，" + "受赠者";
              }
              break;
            case "2":
              if (roleName == "") {
                roleName = "捐赠者";
              } else {
                roleName = roleName + "，" + "捐赠者";
              }
              break;
            case "3":
              if (roleName == "") {
                roleName = "捐献者";
              } else {
                roleName = roleName + "，" + "捐献者";
              }
              break;
            case "4":
              if (roleName == "") {
                roleName = "救护者";
              } else {
                roleName = roleName + "，" + "救护者";
              }
              break;
          }
        });
      }else{
        roleName="--";
      }
      return roleName;
    },
  },
};
</script>

<style scoped>
upload-demo >>> .el-upload input[type="file"] {
  display: none !important;
}
.el-date-editor >>> .el-input__icon {
  display: none;
}

.el-date-editor >>> .el-input__inner {
  width: 90%;
}
.hideFile >>> .el-upload--picture-card {
  display: none !important;
}
.el-dialog__wrapper >>> .el-dialog .el-dialog__footer .el-button--primary {
  display: none;
}
</style>
<style>
.hideButton .dialog-footer >>> .el-button--primary {
  display: none;
}
</style>

